<template>
  <BaseCard
    :result="{
      orgName: searchResult.secondary_organization.name,
      orgLink: searchResult.link,
      tagName: $t(`search.documents.tagName`),
      tagLink: `${searchResult.link}/documents`,
      id: searchResult.id,
      type: searchResult.type,
      result_position: resultPosition,
      display_text: searchResult.name,
      category: 'search_result',
    }"
    class="document-card result-card"
    @result-clicked="handleResultClick"
  >
    <template #preview>
      <div class="preview-fallback">
        <Icon
          name="lucide:file-text"
          size="24"
        />
      </div>
    </template>
    <template #result-content>
      <a
        :href="url"
        class="title"
        data-testid="document-card-title"
        @click.stop="handleResultClick"
      >
        {{ searchResult.name }}
      </a>
      <div class="bottom-bar">
        <!-- <button
          v-if="!isMobileView"
          class="download-button"
          :aria-label="$t('search.download', { docName: searchResult.name, fileType: searchResult.file_extension })"
          data-testid="document-card-download-button"
          @click.stop="downloadFile"
        >
          <Icon
            name="lucide:download"
            size="14"
          />
          {{ $t('search.documents.downloadTag') }}
        </button> -->
        <span
          class="size"
          data-testid="document-card-file-size"
          >{{ $t('search.documents.fileSize') }}: {{ searchResult.file_size }}</span
        >
        <PublishedUpdatedDate :search-result="searchResult" />
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from './BaseCard.vue';
import PublishedUpdatedDate from './PublishedUpdatedDate.vue';
// import { useScreenBreakpoints } from '@/composables/useBreakpoints';
import { computed } from 'vue';
// const { isMobileView } = useScreenBreakpoints();

const props = defineProps({
  searchResult: {
    type: Object,
    required: true,
  },
  resultPosition: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['result-clicked']);

const url = computed(() => {
  return `${props.searchResult.url}`;
});

async function handleResultClick() {
  await navigateTo(url.value, { external: true });
  emit('result-clicked', {
    position: props.resultPosition,
    url: url.value,
  });
}

// function downloadFile() {
//   if (!props.searchResult || !props.searchResult.url) {
//     console.error('Document URL not available');
//     return;
//   }

//   window.open(props.searchResult.url, '_blank');
// }
</script>

<style lang="scss" scoped>
@use '../../global/scss/mixins/_breakpoints.scss' as bp;

.document-card {
  --background-color: var(--color-orange-50);
  --text-color: var(--color-orange-500);

  --color-orange-50: #fffaf4;
  --color-orange-500: #f39529;
  --color-purple-300: #d6c2e0;
  --color-purple-700: #4b1f6d;
  --color-text-secondary: #474747;
  --color-text-tertiary: #949494;

  .title {
    line-height: 120%;
  }

  .bottom-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;

    .size {
      font-size: 12px;
      color: var(--color-text-secondary);
    }

    .download-button {
      display: inline-flex;
      padding: 4px 8px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 100px;
      background: var(--secondary-button-background);
      border: var(--secondary-button-border);
      cursor: pointer;
      color: var(--secondary-button-text);
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 16px;
      letter-spacing: 0.5px;
      &:hover {
        background-color: var(--secondary-button-hover);
      }
      &:focus-visible {
        outline: var(--secondary-button-focus-outline);
        outline-offset: 1px;
        border: var(--secondary-button-hover-border);
      }
    }
  }
}
@include bp.screen('<=sm') {
  .document-card {
    .bottom-bar {
      align-items: flex-start;
      flex-direction: column-reverse;
    }
  }
}
</style>
